import companies from '@/utils/api/companies';

export default {
    namespaced: true,
    state: () => ({
        rawCompanies: [],
        totalCompaniesAmount: null
    }),
    getters: {
        filterableCompanies: state => {
            return state.rawCompanies.map(el => ({
                value: el.id,
                text: el.name
            }));
        }
    },
    mutations: {
        SET_RAW_COMPANIES (state, payload) {
            state.rawCompanies = payload;
        },
        SET_TOTAL_COMPANIES_AMOUNT (state, payload) {
            state.totalCompaniesAmount = payload;
        }
    },
    actions: {
        getCompanies ({ commit }, additionalParams = null) {
            commit('SET_RAW_COMPANIES', []);

            const params = {
                'stats[total]': 'count',
                sort: 'name'
            };

            if (additionalParams) {
                Object.keys(additionalParams).forEach(k => {
                    params[k] = additionalParams[k];
                });
            }

            return companies.getCompanies(params)
                .then(({ data }) => {
                    commit('SET_RAW_COMPANIES', data.data.map(el => ({
                        id: el.id,
                        ...el.attributes
                    })));

                    if (data.meta.stats) {
                        commit('SET_TOTAL_COMPANIES_AMOUNT', data.meta.stats.total.count);
                    }
                });
        },
        getCompaniesLazyLoading ({ state, commit }, additionalParams = null) {
            const params = {
                'stats[total]': 'count',
                sort: 'name'
            };

            if (additionalParams) {
                Object.keys(additionalParams).forEach(k => {
                    params[k] = additionalParams[k];
                });
            }

            return companies.getCompanies(params)
                .then(({ data }) => {
                    const result = [...state.rawCompanies].concat(data.data.map(el => ({
                        id: el.id,
                        ...el.attributes
                    })));

                    commit('SET_RAW_COMPANIES', result);

                    if (data.meta.stats) {
                        commit('SET_TOTAL_COMPANIES_AMOUNT', data.meta.stats.total.count);
                    }
                });
        }
    }
};
